import { Account } from 'src/app/shared/account/account.types';
import { ICreateAccount } from 'src/app/shared/account/create-account.helper';

export interface IAdvertiser extends ICreateAccount {
  accountType: Account.Type.ADVERTISER;
  sellerIds?: string[];
  brands?: string[];
}

export const AdvertiserTypes = {
  STANDARD: 'STANDARD',
  SELLER: 'SELLER',
} as const;

export type AdvertiserTypes = keyof typeof AdvertiserTypes;

export const AdvertiserStatus = {
  ACTIVE: 'ACTIVE',
  BLOCKED: 'BLOCKED',
  DELETED: 'DELETED',
} as const;

export type AdvertiserStatus = typeof AdvertiserStatus[keyof typeof AdvertiserStatus];

export namespace Advertiser {
  export interface IStatsForWhiteLabel {
    advertiserId: string;
    advertiserName: string;
    advertiserStatus: AdvertiserStatus;
    statsDateFrom: string;
    statsDateTo: string;
    campaignsCount: number;
    adsCount: number;
    soldItemsCount: number;
    income: number;
    cost: number;
  }

  export interface IDetails {
    id: string,
    name: string,
    currency: string,
    companyNIP: string,
    companyName: string,
    mobilePhone: string,
    email: string,
    address: {
      id: string,
      country: string,
      street: string,
      houseNumber: string,
      apartmentNumber: string,
      postalCode: string,
      city: string
    },
    correspondenceAddress: {
      id: string,
      country: string,
      street: string,
      houseNumber: string,
      apartmentNumber: string,
      postalCode: string,
      city: string
    },
    showCorrespondenceAddress: boolean,
    userId: string,
    authGroupName: string,
    accessListType: string,
    status: string,
    selfAdvertiser: boolean,
    bannersEnabled: boolean,
    whiteLabel: string,
    advertiserType: AdvertiserTypes,
    sellerIds: string[],
    brands: string[],
  }
}
